import { render, staticRenderFns } from "./custom-product-new.vue?vue&type=template&id=353cf43a&"
import script from "./custom-product-new.vue?vue&type=script&lang=js&"
export * from "./custom-product-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports